import * as  React from 'react';
import { Col, Button, Glyphicon } from 'react-bootstrap';
import { File} from '../../store/types';
import { ColumnsCount } from './types';
import './index.css';

interface TileProps {
    index: number;
    file: File;
    deleteFile: (index: number) => void;
    downloadFile: (index: number) => void;
    openGallery: (index: number) => void;
    nCols: ColumnsCount;
};

export const maxColNb = 4;

export class Tile extends React.Component<TileProps> {
  constructor(props: TileProps) {
    super(props);

    this.deleteFile = this.deleteFile.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.openGallery = this.openGallery.bind(this);
  }

  render() {
    const { file, nCols } = this.props;
    const { preview, name } = file;

    return (
      <Col xs={12 / 1} sm={12 / 2} md={12 / 3} lg={12 / maxColNb} className="TileCols">
        <div className="TileBorder">
          <img src={preview} alt={name} className="TileImage" onClick={this.openGallery} />
          <div>
            <h6 className="TileFileName" title={name} onClick={this.openGallery}>{name}</h6>
            { (nCols !== 1) ?
            <div className="btn-group TileButtons pull-right">
              <Button onClick={this.deleteFile}>
                <Glyphicon glyph="trash" />
              </Button>
              <Button onClick={this.downloadFile} className="pull-right">
                <Glyphicon glyph="download-alt" />
              </Button>
            </div>
            : null
            }
          </div>
        </div>
      </Col>
    );
  }

  deleteFile() {
      this.props.deleteFile(this.props.index);
  }

  downloadFile() {
      this.props.downloadFile(this.props.index);
  }

  openGallery() {
      this.props.openGallery(this.props.index);
  }
}





// WEBPACK FOOTER //
// ./src/components/fileeditor/Tile.tsx